import request from './request'

export default (() => ({
  signIn(ticketId) {
    return request.auth('get', 'user/ticket')({ ticketId })
  }
}))()
